module.exports = __webpack_public_path__ + "static/media/logo-white.46d75668.png";